import { render, staticRenderFns } from "./NetworkSuppliersCard.vue?vue&type=template&id=838cb7c2&scoped=true&"
import script from "./NetworkSuppliersCard.vue?vue&type=script&lang=js&"
export * from "./NetworkSuppliersCard.vue?vue&type=script&lang=js&"
import style0 from "./NetworkSuppliersCard.vue?vue&type=style&index=0&id=838cb7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838cb7c2",
  null
  
)

export default component.exports